<script setup lang="ts">
import { useQuizterStore } from '../stores/quizterStore';
import Card from './Card.vue';
import NextButton from './NextButton.vue';
import useLocale from '../../composables/use-locale';
import { configHelper } from '@ilteducation/config';

const { t } = useLocale();

const quizterStore = useQuizterStore();

const goToQuizter = () => {
  quizterStore.reset();
  // Check environment, if staging => dev.quizter.gg, else quizter.gg
  if (configHelper.environment() === 'production') {
    window.location.href = 'https://quizter.gg';
  } else {
    window.location.href = 'https://dev.quizter.gg';
  }
};
</script>

<template>
  <Card max-width="500" data-testid="quizter-game-error">
    <div class="d-flex flex-column align-center justify-center pa-4 mt-8">
      <div class="d-flex flex-column align-center gr-4">
        <v-icon icon="fa:fawsb fa-circle-exclamation" color="white" size="64"></v-icon>

        <div class="d-flex flex-column align-center ga-3">
          <h1 class="chalkduster-font text-white text-center text-h5 ma-0">
            {{ t('game_error.title') }}
          </h1>
          <p class="chalkboard-font text-white text-center text-body-1 ma-0">
            {{ t('game_error.description') }}
          </p>
        </div>
      </div>

      <div class="d-flex flex-column align-center ga-3 mt-12">
        <NextButton @click="goToQuizter">
          {{ t('game_error.button_join_another') }}
        </NextButton>
      </div>
    </div>
  </Card>
</template>
